<template>
    <div id="app">
        <router-view/>
        <CToaster
        v-for="(toaster, toasterKey) in toasters"
        :position="toasterKey"
        :key="'toaster' + toasterKey"
        >
            <template v-for="(toast, key) in toaster">
                <CToast
                    :key="'toast' + key"
                    :show="true"
                    v-bind="toast"
                    :style="{backgroundColor: toast.type}"
                >
                    {{ toast.body }}
                </CToast>
            </template>
        </CToaster>
    </div>
</template>
<script>
export default {
    data() {
        return {
            toasts: this.$store.state.toasts
        }
    },
    computed : {
        toasters () {
            return this.toasts.reduce((toasters, toast) => {
                toasters[toast.position] = toasters[toast.position] || []
                toasters[toast.position].push(toast)
                return toasters
            }, {});
        }
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
    // Import Main styles for this application
    @import 'assets/scss/style';
    @import 'assets/scss/spinkit.min';
</style>
<style>
    body{
        color: rgba(28, 22, 79) !important;
    }
    input{
        height: 40px !important;
    }
    .foto-lista{
        height: 100%;
        max-height: 110px !important;
    }
    .backgroud-load{
        opacity: 0.3;
    }
    .loader-page-all{
        opacity: 0.6 !important;
        position: absolute;
        left: 51%;
        top: 30%;
        z-index: 99999;
    }
    .modal-info .modal-header{
        background-color: rgba(28, 22, 79) !important;
    }
    .c-app{
        color: rgba(28, 22, 79) !important;
    }
    .form-control{
        color: rgba(28, 22, 79) !important;
    }
    .dropdown-item:hover, .dropdown-item:focus{
        background-color: rgba(165, 137, 50,0.8);
    }
    .c-sidebar{
        background: rgba(28, 22, 79);
    }
    .c-sidebar-brand{
        background: #fff !important;
    }
    .form-control:focus,
    .custom-file-input:focus ~ .custom-file-label {
        color: rgba(28, 22, 79);
        background-color: #fff;
        border-color: rgba(165, 137, 50,0.7) !important;
        box-shadow: 0 0 0 0.1rem rgba(165, 137, 50,0.8) !important;
    }
    .vs__open-indicator{
        fill:rgba(165, 137, 50,0.8) !important;
    }
    .vs__dropdown-toggle{
        padding-bottom: 5px !important;
        padding-top: 3px !important;
    }
    .toast {
        color: #fff;
    }
    .card-option-table{
        margin-bottom: 15px;
        margin-top: 15px;
    }
    .select-page-div label{ 
        margin-right: 5px;
    }
    .table th, .table td{
        font-size: 15px;
        color: rgba(28, 22, 79);
    }
    .table-hover tbody tr:hover{
        color: rgba(28, 22, 79);
        background-color: rgba(165, 137, 50,0.1);
    }
    
    thead tr {
        background-color: white !important;
    }
    
    .btn-outline-primary{
        color: rgba(28, 22, 79);
        border-color: rgba(28, 22, 79);
        border: 1.5px solid;
        font-weight: 600;
        text-transform: uppercase;
    }
    .btn-outline-primary:hover{
        color: rgba(28, 22, 79);
        border-color: rgba(28, 22, 79);
        background-color: rgba(165, 137, 50,0.6);
    }
</style>